module.exports = __webpack_public_path__ + "media/images/daddio2-0147f20889151841fbbd0a6a5903050e.jpg";